import { render } from "./RegisteredAccountsWidget.vue?vue&type=template&id=6a92c933&scoped=true&ts=true"
import script from "./RegisteredAccountsWidget.vue?vue&type=script&lang=ts"
export * from "./RegisteredAccountsWidget.vue?vue&type=script&lang=ts"

import "./RegisteredAccountsWidget.vue?vue&type=style&index=0&id=6a92c933&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a92c933"]])

export default __exports__